import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { dateFormat } from "../../../util/DateUtil";
import { findByAluno } from "../api-aluno-turma";
import Loading from "../../UI/Loading";
import { errorMessage } from "../../../util/ConfirmAlertUtil";

export default function AlunoTurmasTable({ aluno }) {
  const [alunoTurmas, setAlunoTurmas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const codAluno = aluno?.codigo;

  useEffect(() => {
    if (!codAluno) return undefined;
    let active = true;
    setIsLoading(true);
    findByAluno(codAluno)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else if (Array.isArray(data)) {
          setAlunoTurmas(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [codAluno]);

  if (isLoading) {
    return (
      <Box py={4}>
        <Loading size={28} description="Carregando turmas..." />
      </Box>
    );
  }

  if (alunoTurmas.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" textAlign="center" py={4}>
        Nenhuma turma vinculada a este aluno.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Turmas do aluno">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Ano Letivo</TableCell>
            <TableCell>Turma</TableCell>
            <TableCell>Entrada</TableCell>
            <TableCell>Saída</TableCell>
            <TableCell>Situação</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alunoTurmas.map((at) => (
            <TableRow key={at.codigo}>
              <TableCell>{at.turma.anoLetivo}</TableCell>
              <TableCell>{at.turma.descricao}</TableCell>
              <TableCell>{at.dataEntrada ? dateFormat(at.dataEntrada) : "--"}</TableCell>
              <TableCell>{at.dataSaida ? dateFormat(at.dataSaida) : "--"}</TableCell>
              <TableCell>
                <Chip
                  size="small"
                  variant="outlined"
                  color={at.ativo ? "success" : "default"}
                  label={at.ativo ? "Ativo" : "Desativado"}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
